import React, { useEffect, useState } from 'react'

export default function TransactionHash({receipt,providerSelected}) {
  const [token, setToken] = useState([])
  const [extUrl, setExtUrl] = useState('')
  useEffect(() => {
    setToken(receipt)
    if(providerSelected === 'Pancakeswap V2'){
      setExtUrl('https://testnet.bscscan.com/tx/')
    }
    if(providerSelected === 'Uniswap V2'){
      setExtUrl('https://rinkeby.etherscan.io/tx/')
    }
  }, [receipt,providerSelected])
  return (
    <div>
      <div className="cardUtil">
        <span className="titleCard d-block">Transaction Receipt</span>
      </div>
      <div className="table-responsive tableScroll scrollCustom" style={{ height: 200 }}>
        <table className="table table-borderless">
          <thead>
            <tr>
              <th>No</th>
              <th>Hash</th>
            </tr>
          </thead>
          <tbody>
            {
              token && token.map((item, key) => {
                return (
                  <tr key={key}>
                    <td>{key+1}</td>
                    <td>
                      <a style={{ color:'blueviolet' }} href={`${extUrl}${item.hash}`} target="_blank" rel="noreferrer">{item.hash}</a>
                    </td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
      </div>
    </div>
  )
}
